import { isExistsLogin } from "../../common/miscellaneous/handleCookies";
import { SignIn } from "../../sign-in/components/SignIn";
import SidebarImage from "../images/HomeImgSection2.png";
import { useNavigate } from "react-router-dom";
import { ButtonA } from "../../common/components/ButtonA";
import StartIcon from "@mui/icons-material/Start";

export function MainSection() {
  const navigate = useNavigate();
  const participantType = localStorage.getItem("participantType");
  const isOpsWorkLog = participantType === "2";
  const isTimeStudy = participantType === "1";

  return (
    <section className="pt-28 pb-12">
      <div className="flex flex-row justify-between">
        <div className="flex flex-col">
          <div className="mt-8">
            <p className="section-home-title">Momentus</p>
            <p className="text-6xl"></p>
            {isExistsLogin() ? (
              <div className="mt-8">
                {isTimeStudy ? (
                  <ButtonA
                    name="Go to Time Study"
                    icon={<StartIcon />}
                    onHandleClick={() => navigate("/task-submission")}
                  />
                ) : null}
                {isOpsWorkLog ? (
                  <ButtonA
                    name="Go to Task Counter"
                    icon={<StartIcon />}
                    onHandleClick={() => navigate("/task-counter-submission")}
                  />
                ) : null}
              </div>
            ) : (
              <p className="text-base mt-4">
                Please login to experience this application
              </p>
            )}
          </div>
          <div className="mt-12">{isExistsLogin() ? null : <SignIn />}</div>
        </div>

        <div id="sidebar-image" className="flex justify-end">
          <img src={SidebarImage} alt="" className="w-5/6 rounded-3xl" />
        </div>
      </div>
    </section>
  );
}
